import {
  emailBriteVerifyAction,
  makeAnimationStartHandler,
  validateAction
} from 'sharedActions/sharedActions';
import { IRON } from 'styles/Colors';

import { passwordChangeAction } from 'reg_redesign/actions';
import { SET_DATA } from 'helpers/Constants';
import { TextField } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { validationText } from 'components/component_lib/Password';
import emptyStyle from 'fields/rebrand/styles/EmptyStyle';
import React, { useState } from 'react';

function RebrandEmail({ dataAttrs, additionalStyle = {}, briteVerify = true }) {
  const dispatch = useDispatch();
  const value = useSelector((state) => state.email);
  const error = useSelector((state) => state.errors.email);
  const presetDisabled = useSelector((state) => state.isDisabled.email);
  const [touched, setTouched] = useState(false);
  const password = useSelector((state) => state.password);
  const [emailHasValue, setEmailHasValue] = useState(false);

  const handleChange = (e) => {
    const val = e.target.value;
    if (val !== '') {
      setEmailHasValue(true);
    } else {
      setEmailHasValue(false);
    }
    dispatch({ type: SET_DATA, payload: { email: val } });
    if (touched || error) {
      dispatch(validateAction('email'));
    }

    if (password) {
      dispatch(passwordChangeAction(password, validationText, true));
    }
  };

  const handleOnBlur = () => {
    setTouched(true);
    if (briteVerify) {
      dispatch(emailBriteVerifyAction());
    } else {
      dispatch(validateAction('email'));
    }
  };

  return (
    <TextField
      css={[
        !value ? emptyStyle : null,
        presetDisabled
          ? {
              background: 'linear-gradient(180deg, #FFFFFF 0%, #F2F2F2 100%)'
            }
          : {},
        additionalStyle
      ]}
      id='email'
      label='Email'
      type='text'
      variant='outlined'
      value={value}
      InputLabelProps={{
        style: { color: IRON },
        shrink: emailHasValue
      }}
      disabled={presetDisabled}
      onChange={handleChange}
      onBlur={handleOnBlur}
      inputProps={{
        onAnimationStart: makeAnimationStartHandler(setEmailHasValue),
        ...dataAttrs
      }}
      error={!!error}
      helperText={error}
      FormHelperTextProps={{ style: { margin: '0', fontSize: '12px' } }}
    />
  );
}
export default RebrandEmail;
